export enum PaymentStatus {
  Done = 0,
  Initial = 1,
  ReadyForPayment = 2,
  InProgress = 3
}

export const PaymentStatusValue: { [key in PaymentStatus]: string } = {
  [PaymentStatus.Done]: "e480cf6b-c061-48a7-a548-97ccfbb02875",
  [PaymentStatus.Initial]: "49301b97-c14a-4f34-b1dd-4597ef2fa5c0",
  [PaymentStatus.ReadyForPayment]: "53fac470-2c95-4f1b-a6d6-67901cd6ac07",
  [PaymentStatus.InProgress]: "7119097e-0a4b-4d45-b4ad-960b9b560c22"
};

export const PaymentStatusLabel: { [key in PaymentStatus]: string } = {
  [PaymentStatus.Initial]: 'PAYMENT.STATUS.INITIAL',
  [PaymentStatus.ReadyForPayment]: 'PAYMENT.STATUS.READY_FOR_PAYMENT',
  [PaymentStatus.Done]: 'PAYMENT.STATUS.DONE',
  [PaymentStatus.InProgress]: 'PAYMENT.STATUS.IN_PROCESS'
};

export const paymentDetailsMap = {
  [PaymentStatus.Initial]: {
    title: 'PAYMENT.STATUS.INITIAL',
    color: '#3c3b44',
    backgroundColor: '#dfdee6',
    id: PaymentStatusValue[PaymentStatus.Initial]
  },
  [PaymentStatus.ReadyForPayment]: {
    title: 'PAYMENT.STATUS.READY_FOR_PAYMENT',
    color: '#d03131',
    backgroundColor: '#f2c4c4',
    id: PaymentStatusValue[PaymentStatus.ReadyForPayment]
  },
  [PaymentStatus.Done]: {
    title: 'PAYMENT.STATUS.DONE',
    color: '#36793d',
    backgroundColor: '#d7e9d8',
    id: PaymentStatusValue[PaymentStatus.Done]
  },
  [PaymentStatus.InProgress]: {
    title: 'PAYMENT.STATUS.IN_PROCESS',
    color: '#d0a029',
    backgroundColor: '#f8ebcc',
    id: PaymentStatusValue[PaymentStatus.InProgress]
  }
};

export enum ErpPaymentStatus {
  success = 4,
  failed = 5
}

export const ErpPaymentStatusValue: { [key in ErpPaymentStatus]: string } = {
  [ErpPaymentStatus.success]: "a20f0672-46f4-4440-a520-00553723bc2d",
  [ErpPaymentStatus.failed]: "9dbba9af-4114-4625-9d84-52b40a5fa98d",
};